export class LotCodeFreezingChild{
 name: string;
}